import $ from 'jquery';
import ComponentBasePrototype from 'ComponentBasePrototype';

export default class RevealableComponent extends ComponentBasePrototype {
  build() {
    this.setHandlers();
  }

  setHandlers() {
    const anchor = this.node.data('anchor');
    const url = window.location.href;

    // Initial page load reveal
    if (url.includes(`#${anchor}`)) {
      this.revealContent();
    }

    this.node.on('click', '.revealable-component__heading', () => {
      this.selectToggleMethod();
    });

    if (anchor) {
      $(window).on('hashchange', (event) => {
        const newUrl = event.originalEvent.newURL;
        if (newUrl.includes(`#${anchor}`)) {
          this.revealContent();
        }
      });
    }
  }

  selectToggleMethod() {
    if (this.node.data('showless')) {
      this.toggleHeadingsAndContent();
    } else {
      this.toggleContent();
    }
  }

  toggleContent() {
    this.node.find('.revealable-component__container').toggleClass('revealable-component__item--open');
    this.node.find('.revealable-component__icon').toggleClass('revealable-component__icon--rotate');
  }

  toggleHeadingsAndContent() {
    this.node.find('.revealable-component__container').toggleClass('revealable-component__item--open');
    this.node.find('.revealable-component__heading').toggleClass('revealable-component__heading--hidden');
  }

  revealContent() {
    if (this.node.data('showless')) {
      this.node.find('.revealable-component__container').addClass('revealable-component__item--open');
      this.node.find('.revealable-component__heading').addClass('revealable-component__heading--hidden');
    } else {
      this.node.find('.revealable-component__container').addClass('revealable-component__item--open');
      this.node.find('.revealable-component__icon').addClass('revealable-component__icon--rotate');
    }
  }
}
